var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsSearch = function SvgIconsSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.333 1.333c3.314 0 6 2.687 6 6 0 1.417-.49 2.719-1.311 3.745l2.45 2.45c.26.26.26.683 0 .943-.24.24-.62.26-.88.056l-.063-.056-2.45-2.45c-1.027.821-2.33 1.312-3.746 1.312-3.313 0-6-2.686-6-6 0-3.313 2.687-6 6-6zm0 1.334c-2.577 0-4.666 2.089-4.666 4.666C2.667 9.911 4.756 12 7.333 12c1.26 0 2.404-.5 3.244-1.312.015-.021.033-.04.052-.06l.06-.051C11.5 9.737 12 8.594 12 7.333c0-2.577-2.09-4.666-4.667-4.666z"
  })));
};
export default SvgIconsSearch;